<template>
  <div>
    <div class="row">
      <form-input class="col-md-5" :model="loc" attribute="domain" :errors="formErrors"
                  placeholder="Domain (bỏ trống = toàn hệ thống)"/>
      <form-select class="col-md-4" :model="loc" attribute="days" :errors="formErrors" :options="mocNgay"/>
      <div class="col-md-3">
        <button class="btn btn-primary mb-1" @click="xem" :disabled="dangTai">Xem</button>
      </div>
    </div>

    <div v-if="data">
      <!-- Cuộc gọi thử tách hẳn: gọi thử là gọi cho chính mình, trộn vào thì tỷ lệ nối
           máy đẹp lên giả tạo và không còn đánh giá được gì -->
      <div class="row text-center mb-2">
        <div class="col"><div class="c-so">{{ data.that.soCuoc }}</div><small class="text-muted">cuộc thật</small></div>
        <div class="col"><div class="c-so">{{ tyLe(data.that.noiMay, data.that.soCuoc) }}</div><small class="text-muted">nối máy</small></div>
        <div class="col"><div class="c-so" :class="{'text-danger': data.that.hong}">{{ data.that.hong }}</div><small class="text-muted">hỏng</small></div>
        <div class="col"><div class="c-so">{{ phut(data.that.tongGiay) }}</div><small class="text-muted">tổng đàm thoại</small></div>
        <div class="col"><div class="c-so">{{ soGon(data.that.token) }}</div><small class="text-muted">token</small></div>
      </div>
      <p class="small text-muted mb-3">
        {{ data.soChienDich }} chiến dịch · {{ data.thu.soCuoc }} cuộc gọi thử (không tính vào số trên)
        <!-- Nối máy mà chưa thu tiền là Callio chạy GPU không công -->
        <span v-if="data.that.daThu !== data.that.noiMay" class="text-danger d-block">
          Lệch thu tiền: {{ data.that.noiMay }} cuộc nối máy nhưng chỉ {{ data.that.daThu }} cuộc đã thu token.
        </span>
      </p>

      <div class="row">
        <div class="col-md-6 mb-3">
          <h6 class="small font-weight-bold">Kết quả (cuộc đã nối máy)</h6>
          <table class="table table-sm mb-0" v-if="coKetQua">
            <tr v-for="(n, k) in data.ketQua" :key="k">
              <td>{{ tenKetQua(k) }}</td>
              <td class="text-right">{{ n }}</td>
            </tr>
          </table>
          <p v-else class="small text-muted mb-0">Chưa có cuộc nào nối máy trong kỳ.</p>
        </div>

        <div class="col-md-6 mb-3">
          <h6 class="small font-weight-bold">Không nối được máy</h6>
          <table class="table table-sm mb-0" v-if="data.hangUp.length">
            <tr v-for="h in data.hangUp" :key="h.ly">
              <td>{{ h.ly }}</td>
              <td class="text-right">{{ h.n }}</td>
            </tr>
          </table>
          <p v-else class="small text-muted mb-0">Không có.</p>
        </div>

        <div class="col-md-6 mb-3">
          <h6 class="small font-weight-bold">Lỗi hệ thống</h6>
          <table class="table table-sm mb-0" v-if="data.loi.length">
            <tr v-for="l in data.loi" :key="l.ly">
              <td class="small">{{ l.ly }}</td>
              <td class="text-right">{{ l.n }}</td>
            </tr>
          </table>
          <p v-else class="small text-muted mb-0">Không có lỗi nào.</p>
        </div>

        <div class="col-md-6 mb-3">
          <!-- Chặn nhiều bất thường nghĩa là danh bạ toàn người đã xin thôi; phải báo
               khách trước khi họ kêu "sao chiến dịch gọi được có mấy cuộc" -->
          <h6 class="small font-weight-bold">Bị cổng chặn gọi</h6>
          <table class="table table-sm mb-0">
            <tr><td>Đã xin thôi nhận quảng cáo</td><td class="text-right">{{ data.cong.opted_out }}</td></tr>
            <tr><td>Chạm trần tần suất</td><td class="text-right">{{ data.cong.rate_capped }}</td></tr>
            <tr><td>Lỗi khi kiểm</td><td class="text-right">{{ data.cong.system }}</td></tr>
          </table>
        </div>
      </div>

      <h6 class="small font-weight-bold">Đang gọi ngay lúc này</h6>
      <table class="table table-sm mb-3" v-if="data.dangChay.length">
        <tr v-for="c in data.dangChay" :key="c.domain">
          <td>{{ c.domain }}</td>
          <td class="text-right" :class="{'text-danger': c.tran && c.dang >= c.tran}">
            {{ c.dang }}<span v-if="c.tran"> / {{ c.tran }}</span>
          </td>
        </tr>
      </table>
      <p v-else class="small text-muted">Không có cuộc nào đang chạy.</p>

      <h6 class="small font-weight-bold">Khách dùng nhiều nhất</h6>
      <div class="table-responsive">
        <table class="table table-sm mb-0" v-if="data.theoKhach.length">
          <thead>
            <tr>
              <th>Domain</th><th class="text-right">Cuộc</th><th class="text-right">Nối máy</th>
              <th class="text-right">Hỏng</th><th class="text-right">Token</th><th class="text-right">Gần nhất</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="k in data.theoKhach" :key="k.domain">
              <td>{{ k.name || k.domain }}</td>
              <td class="text-right">{{ k.soCuoc }}</td>
              <td class="text-right">{{ tyLe(k.noiMay, k.soCuoc) }}</td>
              <td class="text-right" :class="{'text-danger': k.hong}">{{ k.hong }}</td>
              <td class="text-right">{{ soGon(k.token) }}</td>
              <td class="text-right small">{{ ngay(k.lanCuoi) }}</td>
            </tr>
          </tbody>
        </table>
        <p v-else class="small text-muted mb-0">Chưa khách nào chạy chiến dịch gọi tự động bằng AI trong kỳ.</p>
      </div>
    </div>

    <p v-else-if="daXem" class="small text-muted mb-0">Không có dữ liệu trong kỳ đã chọn.</p>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  data() {
    return {
      loc: {domain: null, days: 7},
      mocNgay: [
        {value: 1, text: '24 giờ qua'},
        {value: 7, text: '7 ngày qua'},
        {value: 30, text: '30 ngày qua'},
        {value: 90, text: '90 ngày qua'},
      ],
      // Nhãn tiếng Việt của `AICallSession.outcome`. Hiện thẳng mã enum thì người trực
      // vận hành phải đi tra nghĩa từng chữ.
      nhanKetQua: {
        ok: 'Nghe hết, đồng ý',
        interest: 'Quan tâm',
        callback: 'Hẹn gọi lại',
        deny: 'Từ chối',
        reject: 'Xin thôi nhận',
        wrong: 'Sai người',
        silent: 'Không nói gì',
        failed: 'Không xong kịch bản',
        null: 'Chưa phân loại',
      },
      data: null,
      daXem: false,
      dangTai: false,
      formErrors: [],
    };
  },
  computed: {
    coKetQua() {
      return this.data && Object.keys(this.data.ketQua).length > 0;
    },
  },
  methods: {
    tenKetQua(k) {
      return this.nhanKetQua[k] || k;
    },
    tyLe(a, b) {
      if (!b) return '—';
      return `${a} (${Math.round(a * 100 / b)}%)`;
    },
    phut(giay) {
      if (!giay) return '0 phút';
      return `${Math.round(giay / 60)} phút`;
    },
    soGon(n) {
      if (!n) return '0';
      if (n >= 1000000) return `${(n / 1000000).toFixed(1)}tr`;
      if (n >= 1000) return `${Math.round(n / 1000)}k`;
      return String(n);
    },
    ngay(ms) {
      return ms ? moment(ms).format('DD/MM HH:mm') : '—';
    },
    xem() {
      this.dangTai = true;
      const loader = this.$loading.show();
      this.$service({
        url: '/tool/ai-voice-monitor',
        method: 'get',
        params: {days: this.loc.days, domain: this.loc.domain || undefined},
      }).then(response => {
        this.data = response.data;
        this.daXem = true;
      }).finally(() => {
        loader.hide();
        this.dangTai = false;
      });
    },
  },
  mounted() {
    this.xem();
  },
};
</script>
<style scoped>
.c-so {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
}
</style>
